import { css } from 'aphrodite/no-important';
import { PartnerLink } from 'components/PartnerLink/PartnerLink';
import { useScrollToTopOnMount } from 'hooks';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useParams } from 'react-router-dom';
import { RootState } from 'redux/store';
import { ROUTE } from 'util/constants';
import { makeSlug } from 'util/helpers';
import { style } from './style';

interface Props {
  isOpen: boolean;
}

interface PartnerPavilionPageParams {
  partnerCategory?: string;
}

export const PartnerPavilion: FC<Props | null> = ({ isOpen }) => {
  useScrollToTopOnMount();

  const { partner_categories: partnerCategories }: { partner_categories: string[] } = useSelector(
    (state: RootState) => state.widget.cms.text.header
  );
  const styles = style();
  const vendors = useSelector((state: RootState) => state.vendors.vendors);
  const { partnerCategory } = useParams<PartnerPavilionPageParams>();

  if (!isOpen) {
    return <Redirect to={ROUTE.HOME} />;
  }

  const categoryFilter = (category: string) => {
    return partnerCategory ? makeSlug(category) === partnerCategory : true;
  };

  const renderPartnersByCategory = (category: string) => {
    return vendors
      .filter((vendor) => vendor.details.categories.includes(category))
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((vendor, index) => {
        const exhibits = vendor.exhibits;

        if (exhibits.length === 0) return null;

        return (
          <PartnerLink key={index} partner={vendor}>
            <img src={vendor.details.logo_url} alt='' />
          </PartnerLink>
        );
      });
  };

  const PartnerTiles = partnerCategories.filter(categoryFilter).map((category, index) => {
    return (
      <div className={css(styles.partnerCategories, index % 2 === 0 ? '' : styles.lightCategory)} key={index}>
        <div className={css(styles.categoryContainer)}>
          <h2 className={css(styles.categoryTitle)} id={makeSlug(category)}>
            {category}
          </h2>
          <div className={css(styles.partnerGrid)}>{renderPartnersByCategory(category)}</div>
        </div>
      </div>
    );
  });
  return (
    <main className={css(styles.mainContainer)}>
      <section className={css(styles.partnerSection)}>{PartnerTiles}</section>
    </main>
  );
};
